import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SearchResultComponent } from './search-result/search-result.component';
import { SearchService } from '../../services/search.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ISearchResponse } from '@shared/constants/models.const';
import { E_QPROPS } from '@shared/constants/enums.const';
import { CategoriesComponent } from '@shared/components/categories/categories.component';
import { PaginatorComponent } from '@shared/components/paginator/paginator.component';
import { MainTemplateComponent } from '@templates/main-template/main-template.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, debounceTime, filter, take } from 'rxjs';
import { HelperService } from '../../services/helper.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ResponsivityService } from '../../services/responsivity.service';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'app-search',
  imports: [
    SearchResultComponent,
    CategoriesComponent,
    PaginatorComponent,
    MainTemplateComponent,
    TranslateModule,
    MatProgressSpinner,
    AsyncPipe,
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
})
export class SearchComponent implements OnInit {
  pageData!: ISearchResponse | undefined;
  searchPrompt: string = '';
  queryParams: any;
  dataLoaded = false;
  isMobileVersion!: BehaviorSubject<boolean>;

  constructor(
    private router: Router,
    private searchService: SearchService,
    private HELPER: HelperService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private translate: TranslateService,
    private resposivityService: ResponsivityService,
  ) {
  }

  get itemsCount(): string {
    if (this.pageData && this.pageData.searchItems && this.pageData.searchItems.totalCount > 0) {
      return `${this.pageData?.searchItems.totalCount} ` + this.translate.instant('items found');
    } else {
      return this.translate.instant('No results found');
    }
  }

  ngOnInit() {
    // First search request
    this.trackParamsSearch();

    // Track url changes to GET search results when params change OR localization changes
    this.router.events.pipe(
      untilDestroyed(this),
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      this.trackParamsSearch();
    });
    this.isMobileVersion = this.resposivityService.isTabletOrMobileOpen;
  }

  trackParamsSearch(): void {
    const params = this.route.snapshot.queryParams;
    if (params) {
      this.searchPrompt = params['prompt'];
      this.queryParams = {
        ...params,
        [E_QPROPS.contentType]: params[E_QPROPS.contentType] ? params[E_QPROPS.contentType] : 0,
      };
    }
    this.dataLoaded = false;
    this.getData();
  }

  getData(): void {
    if (this.searchPrompt) {
      this.searchService.getSearchRequest(this.queryParams)
        .pipe(
          take(1),
          debounceTime(500),
        )
        .subscribe(data => {
          this.pageData = data;
          this.dataLoaded = true;
          this.cd.markForCheck();

          this.HELPER.$pageData.next({
            ...data,
            title: `Search results for "${this.searchPrompt}"`,
            searchTerms: this.searchPrompt,
            resultsCount: data.searchItems.totalCount,
          });

        });
    }
  }
}
